/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_PAYMENT = gql`
query GetPaymentStats($filter: getPaymentStatsFilter) {
  getPaymentStats(filter: $filter) {
    data {
      name
      count
      totalAmount
    }
    ticketCashierStats {
      summary {
        currency
        online {
          orderCount
          ticketCount
          totalAmount
        }
        offline {
          orderCount
          ticketCount
          totalAmount
        }
      }
    }
  }
}
`;
